const Places = [
  {
    city: "Lipa City",
    yearRange: "1993-1995",
    latitude: 13.941876,
    longitude: 121.164420
  },
  {
    city: "Mönchengladbach",
    yearRange: "2000-2002",
    latitude: 51.180457,
    longitude: 6.442804
  },
  {
    city: "Okinawa",
    yearRange: "2009-2010",
    latitude: 34.7788,
    longitude: 136.9082
  },
  {
    city: "San Antonio",
    yearRange: "2011-2016",
    latitude: 29.583045,
    longitude: -98.619656
  },
  {
    city: "Denver",
    yearRange: "2016-2018",
    latitude: 39.739236,
    longitude: -104.990251
  },
  {
    city: "Toronto",
    yearRange: "2018-∞",
    latitude: 43.646540,
    longitude: -79.384749
  },
];

export default Places;



// WEBPACK FOOTER //
// ./src/data/places.js